import { render, staticRenderFns } from "./ContentsPage.vue?vue&type=template&id=3699dee5&"
import script from "./ContentsPage.vue?vue&type=script&lang=ts&"
export * from "./ContentsPage.vue?vue&type=script&lang=ts&"
import style0 from "./ContentsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports